import { render, staticRenderFns } from "./signature.vue?vue&type=template&id=316bafdf&scoped=true"
import script from "./signature.vue?vue&type=script&lang=js"
export * from "./signature.vue?vue&type=script&lang=js"
import style0 from "./signature.vue?vue&type=style&index=0&id=316bafdf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316bafdf",
  null
  
)

export default component.exports